import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { parentalConsentCopy } from '@/Pages/ParentalConsent/copy';
import '@/Pages/ParentalConsent/ParentalConsentPage.sass';

export function ParentalConsentHeader(): JSX.Element {
  return (
    <Box
      component="header"
      className="parental-consent-header"
      data-testid="parental-consent-header"
    >
      <Typography
        component="p"
        variant="overline"
        className="parental-consent-header__identity"
      >
        {parentalConsentCopy.productName}
      </Typography>

      <Typography
        component="h1"
        variant="h5"
        className="parental-consent-header__title"
      >
        {parentalConsentCopy.title}
      </Typography>

      <Typography
        component="p"
        variant="body2"
        className="parental-consent-header__subtitle"
      >
        {parentalConsentCopy.subtitle}
      </Typography>
    </Box>
  );
}
